import { sanitizeCurrencyForPdf } from '@features/exports/utils/sanitizeCurrencyForPdf'

import { formatAmountWithCurrency } from '../../../../../../../../../../utils/formatAmountWithCurrency'

interface FormatAmountProps {
  value: number | undefined
  locale?: string
  currency?: string
}

export const formatAmount = ({ currency, locale, value }: FormatAmountProps) =>
  sanitizeCurrencyForPdf(
    formatAmountWithCurrency({
      amount: typeof value === 'number' ? value : 0,
      currency,
      locale,
    }),
  )
